// src/services/ApiService.js
const apiService = async ({ method, url, data = null, headers = {} }) => {
  const apiHost = process.env.REACT_APP_API_URL || "http://localhost:3000/api";
  
  // ดึง token จาก localStorage
  const token = localStorage.getItem("token");

  // ตรวจสอบว่า data เป็น FormData หรือไม่
  const isFormData = data instanceof FormData;
  
  const defaultHeaders = {
    // ไม่ตั้ง Content-Type สำหรับ FormData เพื่อให้ browser ตั้งค่า boundary อัตโนมัติ
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...headers,
  };

  // เพิ่ม Authorization header ถ้ามี token
  if (token) {
    defaultHeaders["Authorization"] = `Bearer ${token}`;
  }

  console.log("API Request:", {
    url: `${apiHost}${url}`,
    method,
    headers: defaultHeaders,
    body: isFormData ? "FormData" : (data ? JSON.stringify(data) : null),
  });

  try {
    const response = await fetch(`${apiHost}${url}`, {
      method,
      headers: defaultHeaders,
      body: isFormData ? data : (data ? JSON.stringify(data) : null),
    });

    const text = await response.text();
    console.log("API URL : ", url);
    console.log("Raw Response : ", text);

    let result;
    try {
      result = JSON.parse(text);
    } catch (e) {
      throw new Error("Response is not valid JSON: " + text);
    }

    if (!response.ok) {
      // ถ้าเป็น 401 Unauthorized ให้ลบ token และ redirect ไป login
      if (response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/wc/login";
      }
      throw new Error(result.message || result.error || `API request failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export default apiService;